import React from "react";
// import WhatsAppIcon from "./WhatsApp.webp";
import { StaticImage } from "gatsby-plugin-image";
import "./WhatsApp.css";

export default function WhatsApp() {
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 100000,
      }}
    >
      <a
        href="https://wa.me/+94773296218"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-button"
      >
        <StaticImage
          src="./WhatsApp.webp"
          alt="WhatsApp Icon"
          className="pop-up-icon"
          loading="lazy"
          width={42}
          height={42}
          fetchpriority="high"
          layout="fullWidth"
          formats={["auto", "webp", "avif"]}
        />
      </a>
    </div>
  );
}
